import React from 'react';

import Typography from '@mui/material/Typography';

export const AddMemberHeader = props => {
    
    const entityLogoUrl = props.info.add_member_header === 0 ? props.info.image : null;
    const customHeaderUrl = props.info.add_member_header === 1
      ? props.info.add_member_image_header
      : null;
    let textHeader = (props.info.add_member_header === 2 || (!entityLogoUrl && !customHeaderUrl)) && props.info.name != null ? props.info.name : null;
    
    return (
          
          <>
          { props.info.add_member_header != 3 ?
          <header className="Header add_member" style={{ backgroundColor: props.info.add_member_header_color != null ? props.info.add_member_header_color : "#ffffff" }}>
            { entityLogoUrl ?
                <img src={entityLogoUrl} className="Header_logo" alt={props.info.name || ""} />
            : customHeaderUrl ?
                <img src={customHeaderUrl} className="Header_logo" alt={props.info.name || ""} />
            : null }
            { textHeader != null ?
                <Typography variant="h1" className="grey8" align="center" style={{ width: "100%", fontSize: "35px" }}>
                    {textHeader}          
                </Typography>
            : null }
          </header>
          : null }
                  
            { props.info.add_member_title ? 
              <>
                <br/>
                <Typography variant="h2" className="grey8" align="center" style={{ width: "100%", fontSize: "25px", margin: "20px 0px" }}>
                  {props.info.add_member_title}              
                </Typography>
              </>
              :
              <span/>
            }
            
        </>
            
    )
}
